// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Leads, Adress } = initSchema(schema);

export {
  Leads,
  Adress
};